import { liveGallery, galleryThumbs } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function GalleryZone() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading index="03" title="现场实况 · 视频图集" note="图文并重，视频同源跟进" onMore={() => {}} />
        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {liveGallery.map((g, i) => (
            <article
              key={i}
              className="group relative cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-100"
            >
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                <img
                  src={galleryThumbs[i]}
                  alt={`看黑料 ${g.tag} 视频封面`}
                  title={`看黑料 ${g.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute inset-0 flex items-center justify-center bg-foreground-950/25 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-50/90 text-primary-600">
                    <i className="ri-play-fill text-2xl" />
                  </span>
                </span>
                <span className="absolute left-2 top-2 flex items-center gap-1 whitespace-nowrap rounded-sm bg-background-50/90 px-1.5 py-0.5 text-[11px] font-medium text-foreground-800">
                  <i className="ri-video-line text-primary-600" />
                  {g.tag}
                </span>
                <span className="absolute bottom-2 right-2 whitespace-nowrap rounded-sm bg-foreground-950/70 px-1.5 py-0.5 font-display text-xs text-background-50">
                  {g.duration}
                </span>
              </div>
              <div className="flex flex-col p-3 md:p-4">
                <h3 className="line-clamp-2 font-heading text-[15px] font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                  {g.title}
                </h3>
                <span className="mt-2 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line" />
                  {g.view} 次播放
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}